import 'katex/dist/katex.min.css';
import Box from '@mui/material/Box';
import React from 'react';
import { renderChemTextToHtml, renderParameterLabelHtml } from '../chemistry/latexChemDisplay';

const chemInlineSx = {
  display: 'inline',
  '& .katex': { fontSize: 'inherit' },
  '& .katex-html': { whiteSpace: 'normal' },
  '& sub, & sup': { fontSize: '0.75em', lineHeight: 0 },
  overflowWrap: 'anywhere',
  whiteSpace: 'pre-wrap',
} as const;

/**
 * Huruf kimia — pipeline sama PDF quotation / berita acara:
 * `Cyanide, CN^-` → Cyanide, CN⁻; `BOD_5` → BOD₅; `Cr^{6+}` → Cr⁶⁺.
 */
export function ChemInline({ text }: { text: string }) {
  const s = text.trim();
  if (!s) return null;
  return (
    <Box
      component="span"
      sx={chemInlineSx}
      dangerouslySetInnerHTML={{ __html: renderChemTextToHtml(s) }}
    />
  );
}

/**
 * Nama parameter + simbol dengan format kimia PDF.
 * Jika nama sudah memuat rumus simbol, simbol tidak diulang.
 */
export function ChemParameterLabel({
  nama,
  simbol,
}: {
  nama?: string | null;
  simbol?: string | null;
}) {
  const html = renderParameterLabelHtml(nama, simbol);
  if (!html) return null;
  return <Box component="span" sx={chemInlineSx} dangerouslySetInnerHTML={{ __html: html }} />;
}
